import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  dark: {
    name: 'dark',
    label: 'Forge Dark',
    bg: '#0a0f1e',
    bgSecondary: '#111827',
    bgCard: '#1a2235',
    border: '#2a3a55',
    text: '#e8f0fe',
    textSecondary: '#8899bb',
    accent: '#00d4ff',
    accentSecondary: '#ff6b35',
    success: '#00e5a0',
    warning: '#ffb830',
    danger: '#ff4d6d',
    gradient: 'linear-gradient(135deg, #0a0f1e 0%, #111827 100%)',
  },
  light: {
    name: 'light',
    label: 'Crystal Light',
    bg: '#f0f7ff',
    bgSecondary: '#ffffff',
    bgCard: '#ffffff',
    border: '#c8dff7',
    text: '#1a2a4a',
    textSecondary: '#5a7a9a',
    accent: '#3a8fd4',
    accentSecondary: '#ff6b35',
    success: '#00c07a',
    warning: '#f59e0b',
    danger: '#ef4444',
    gradient: 'linear-gradient(135deg, #e8f4ff 0%, #f0f7ff 100%)',
  },
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(null);
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('vf_theme');
    if (saved && themes[saved]) {
      setTheme(themes[saved]);
    } else {
      setShowPicker(true);
    }
  }, []);

  const selectTheme = (themeName) => {
    localStorage.setItem('vf_theme', themeName);
    setTheme(themes[themeName]);
    setShowPicker(false);
  };

  return (
    <ThemeContext.Provider value={{ theme, selectTheme, showPicker, themes }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
